import React, { useEffect, useState } from 'react';
import AppShell from '@/components/AppShell';
import client from '@/lib/api';
import { Card } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Skeleton } from '@/components/ui/skeleton';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const CATS = ['All', 'Unsafe Driving', 'Hours-of-Service', 'Driver Fitness', 'Controlled Substances', 'Vehicle Maintenance', 'Crash Indicator'];

export default function Violations() {
  const [items, setItems] = useState(null);
  const [cat, setCat] = useState('All');
  useEffect(() => { setItems(null); const u = cat === 'All' ? '/violations' : `/violations?basic_category=${encodeURIComponent(cat)}`; client.get(u).then((r) => setItems(r.data)).catch(() => setItems([])); }, [cat]);
  return (
    <AppShell title="Violations">
      <div className="mb-4 flex justify-end">
        <Select value={cat} onValueChange={setCat}><SelectTrigger className="w-56" data-testid="violations-category-filter"><SelectValue /></SelectTrigger><SelectContent>{CATS.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent></Select>
      </div>
      <Card className="overflow-hidden">
        {items === null ? <div className="space-y-2 p-4">{[1,2,3].map(i=><Skeleton key={i} className="h-12" />)}</div> : items.length === 0 ? <div className="p-12 text-center text-sm text-muted-foreground">No violations found.</div> : (
          <div className="overflow-x-auto"><Table>
            <TableHeader><TableRow><TableHead>Date</TableHead><TableHead>Driver</TableHead><TableHead>Code</TableHead><TableHead>Description</TableHead><TableHead>BASIC Category</TableHead><TableHead>Severity</TableHead></TableRow></TableHeader>
            <TableBody>{items.map((it) => (
              <TableRow key={it.id}><TableCell>{it.date ? new Date(it.date).toLocaleDateString() : '-'}</TableCell><TableCell>{it.driver_name || '-'}</TableCell><TableCell className="font-mono text-xs">{it.code}</TableCell><TableCell>{it.description}</TableCell><TableCell><span className="rounded bg-muted px-2 py-0.5 text-xs">{it.basic_category}</span></TableCell><TableCell>{it.severity}</TableCell></TableRow>
            ))}</TableBody>
          </Table></div>
        )}
      </Card>
    </AppShell>
  );
}
